import React from "react";
import {
  FaShieldAlt,
  FaUsers,
  FaLeaf,
  FaClock,
  FaStar,
  FaTools,
} from "react-icons/fa";
import InstallPWAButton from "./InstallPWAButton";
import { useTranslation } from "react-i18next";
import i18next from "i18next";

const CarWashFeatures = () => {
    const{t}=useTranslation();
  const features = [
    {
      id: 1,
      icon: FaShieldAlt,
      title: t("feature1_title"),
      description:t("feature1_description"),
      
    },
    {
      id: 2,
      icon: FaUsers,
      title: t("feature2_title"),
      description:t("feature2_description"),
    },
    {
      id: 3,
      icon: FaLeaf,
      title: t("feature3_title"),
      description:t("feature3_description"),
    },
    {
      id: 4,
      icon: FaClock,
      title: t("feature4_title"),
      description:t("feature4_description"),
    },
    {
      id: 5,
      icon: FaStar,
      title: t("feature5_title"),
      description:t("feature5_description"),
    },
    {
      id: 6,
      icon: FaTools,
      title: t("feature6_title"),
      description:t("feature6_description"),
    },
  ];

  return (
    <section dir={i18next.language === "ar" ? "rtl" : "ltr"} className="py-16 px-4  w-full bg-white">
      {/* Section Title */}
      <h1 className="text-4xl md:text-5xl font-bold text-[#222222] text-center mb-16">
        {t("features_title")}
      </h1>

      {/* Features Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16">
        {/* Left Column */}
        <div className="space-y-8">
          {features.slice(0, 3).map((feature) => (
            <div key={feature.id} className="flex items-start gap-4">
              {/* Icon */}
              <div className="flex-shrink-0 w-12 h-12 bg-[#66B8D9] bg-opacity-10 rounded-lg flex items-center justify-center">
                <feature.icon className="w-6 h-6 text-[#66B8D9]" />
              </div>

              {/* Content */}
              <div className="flex-1">
                <h3 className="text-xl font-semibold text-[#222222] mb-2">
                  {feature.title}
                </h3>
                <p className="text-[#666666] leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Right Column */}
        <div className="space-y-8">
          {features.slice(3, 6).map((feature) => (
            <div key={feature.id} className="flex items-start gap-4">
              {/* Icon */}
              <div className="flex-shrink-0 w-12 h-12 bg-[#66B8D9] bg-opacity-10 rounded-lg flex items-center justify-center">
                <feature.icon className="w-6 h-6 text-[#66B8D9]" />
              </div>

              {/* Content */}
              <div className="flex-1">
                <h3 className="text-xl font-semibold text-[#222222] mb-2">
                  {feature.title}
                </h3>
                <p className="text-[#666666] leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <InstallPWAButton />
    </section>
  );
};

export default CarWashFeatures;
